import { addDays, subYears, endOfYear, endOfMonth, startOfYear, endOfQuarter, startOfMonth, startOfQuarter } from 'date-fns';
import { formatDateLong, toDatestampArray } from '~/models/time';
import { formatNumericUSDate } from '~/utils';
import { DateRange } from '../types';
export const dateRangePresetsTextsPath = 'dateRange.presets';
export function getDateRangeOptions(texts) {
    return [
        {
            value: DateRange.Last12Months,
            text: texts.last12Months()
        },
        {
            value: DateRange.CurrentMonth,
            text: texts.thisMonth()
        },
        {
            value: DateRange.CurrentQuarter,
            text: texts.thisQuarter()
        },
        {
            value: DateRange.CurrentYear,
            text: texts.thisYear()
        },
        {
            value: DateRange.AllTime,
            text: texts.allTime()
        },
        {
            value: DateRange.Custom,
            text: texts.custom()
        }
    ];
}
export function getDataRangeNames(texts) {
    return {
        [DateRange.Last12Months]: ()=>texts.last12Months(),
        [DateRange.CurrentMonth]: ()=>texts.thisMonth(),
        [DateRange.CurrentQuarter]: ()=>texts.thisQuarter(),
        [DateRange.CurrentYear]: ()=>texts.thisYear(),
        [DateRange.AllTime]: ()=>texts.allTime(),
        [DateRange.Custom]: (start, end)=>texts.customRange({
                start: dateToStr(start),
                end: dateToStr(end)
            })
    };
}
export const dateToStr = (date)=>formatDateLong(toDatestampArray(new Date(date)));
export function calculateEndDate(endDate, dataRange, now) {
    switch(dataRange){
        case DateRange.Last12Months:
            return formatNumericUSDate(now);
        case DateRange.CurrentMonth:
            return formatNumericUSDate(endOfMonth(now));
        case DateRange.CurrentQuarter:
            return formatNumericUSDate(endOfQuarter(now));
        case DateRange.CurrentYear:
            return formatNumericUSDate(endOfYear(now));
        case DateRange.AllTime:
            return '';
        default:
            return endDate;
    }
}
export function calculateStartDate(startDate, dataRange, now) {
    switch(dataRange){
        case DateRange.Last12Months:
            return formatNumericUSDate(addDays(subYears(now, 1), 1));
        case DateRange.CurrentMonth:
            return formatNumericUSDate(startOfMonth(now));
        case DateRange.CurrentQuarter:
            return formatNumericUSDate(startOfQuarter(now));
        case DateRange.CurrentYear:
            return formatNumericUSDate(startOfYear(now));
        case DateRange.AllTime:
            return formatNumericUSDate(new Date('2023-01-01'));
        default:
            return startDate;
    }
}
